// @flow

import window from 'window';

import _ from 'lodash';

import Q from 'q';

import deprecate from 'util-deprecate';

import normalizeUrl from 'normalize-url';


class OnBeforeUnloadHandler {
	_callbacks: Array<() => boolean> = [];
	_isAlertSuppressed: boolean = false;

	constructor () {
		window.addEventListener('beforeunload', (e) => {
			const somethingDoesNotWantToBeClosed = _.some(this._callbacks, cb => cb());

			if (!somethingDoesNotWantToBeClosed || this._isAlertSuppressed) {
				this._isAlertSuppressed = false;
				return undefined;
			}

			const message = 'Все данные будут потеряны! Вы уверены, что хотите покинуть страницу?';
			e.returnValue = message;
			return message;
		});
	}

	/**
	 * @deprecated use `redirectWithoutAlert` instead
	 */
	suppressNextOnBeforeUnload = deprecate(() => {
		this._isAlertSuppressed = true;
	}, '`suppressNextOnBeforeUnload` is deprecated, use `redirectWithoutAlert` instead.');

	redirectWithoutAlert (newHref: string, isNormalizeNeeded = true) {
		this._isAlertSuppressed = true;
		window.location.href = isNormalizeNeeded
			? this._normalizeUrl(newHref)
			: newHref;
		return Q.defer().promise;
	}

	redirectToNewWindowWithoutAlert (newHref: string) {
		this._isAlertSuppressed = true;
		window.open(this._normalizeUrl(newHref), '_blank');
	}

	reloadWithoutAlert () {
		this._isAlertSuppressed = true;
		window.location.reload();
	}

	push (callback: () => boolean) {
		this._callbacks.push(callback);
	}

	remove (callback: () => boolean) {
		_.pull(this._callbacks, callback);
	}

	_normalizeUrl (newHref: string) {
		return normalizeUrl(newHref, {
			stripWWW: false,
			stripFragment: false,
			removeQueryParameters: false,
		});
	}
}

module.exports = new OnBeforeUnloadHandler();
